import { defineComponent as _defineComponent } from 'vue'
import conditionsUrl from "../../../computed/conditionsUrl"


export default /*#__PURE__*/_defineComponent({
  __name: 'TermsAndConditions',
  setup(__props) {

// Imported copmuted
const content = window.content

return { __sfc: true,content, conditionsUrl }
}

})